import { Position } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import classnames from 'classnames'

import type { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import {
  getFeatureSectionTwoAnalytics,
  useFeatureSectionTwoImpressionRef,
} from '@src/components/widgets/use-ia-impression'

import { resolveSectionBackground } from '../widget-background'
import { WidgetMedia, WidgetRichText } from '../widget-content'

import styles from './media-text-mosaic.module.scss'

import type { MediaTextMosaicWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * MEDIA_TEXT_MOSAIC widget (legacy path): mosaic of media + text rows; `position` (LEFT/RIGHT)
 * decides which side the media sits on so stacked rows alternate. Styling in the SCSS module.
 */
export function MediaTextMosaicWidgetLegacy(props: PLTypedWidgetProps<MediaTextMosaicWidgetData>) {
  const data = props.data.mediaTextMosaicData
  const items = data?.items ?? []
  // MediaTextMosaic sections are FS2 by definition, so no isFS2NewDesignShape gate (empty sections early-return below).
  const impressionRef = useFeatureSectionTwoImpressionRef(getFeatureSectionTwoAnalytics(data))
  if (items.length === 0) return null

  return (
    <div ref={impressionRef}>
      <section className={styles.section} data-testid="media-text-mosaic-widget">
        {items.map((item, index) => {
          // Per-row CMS bg: cast until the proto carries `classNames` (pending BE contract).
          const classNames = (item as { classNames?: string[] } | undefined)?.classNames
          const backgroundColor = resolveSectionBackground(classNames)
          return (
            <div
              key={`${item.title}-${index}`}
              className={classnames(styles.row, item.position === Position.RIGHT && styles.rowReverse)}
            >
              <WidgetMedia media={item.media} className={styles.media} />
              <div
                className={classnames(styles.text, classNames)}
                style={backgroundColor ? { backgroundColor } : undefined}
              >
                {item.title ? <h3 className={styles.title}>{item.title}</h3> : null}
                <WidgetRichText data={item.subTitle} className={styles.body} />
              </div>
            </div>
          )
        })}
      </section>
    </div>
  )
}
